





















































import { Accessory } from "@/models/products/accessory";
import { Component } from "vue-property-decorator";
import Collections from "./Collections";
import Search from "@/components/elements/utility/Search.vue";
import DataTable from "@/components/elements/utility/Table.vue";
import QtyPicker from "@/components/elements/utility/QtyPicker.vue";
import AddListToQuoteFooter from "@/components/footer/AddListToQuoteFooter.vue";
import { ProductType } from "@/models/products/product";
import { LineItem, Note } from "@/models/order/order";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions } from "@/store/modules/order/types";
import { EventBus } from "@/event-bus";
import { GlobalGetters } from "@/store/modules/global/types";
import PriceSurchargeModal from "@/components/elements/modal/PriceSurchargeModal.vue";
import { PriceLevel } from "@/models/netsuite/netsuite";

@Component({
  components: {
    Search,
    DataTable,
    QtyPicker,
    AddListToQuoteFooter,
    PriceSurchargeModal
  }
})
export default class AccessoryMenu extends Collections {
  @(namespace(StoreModule.Order).Action(OrderActions.AddLineItem))
  addItem!: (value: LineItem) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetMultiplier))
  multiplier!: PriceLevel | null;

  private search = "";
  protected ProductType = ProductType;
  protected lineItems: LineItem[] = [];

  get multiplierValue(): number {
    if (!this.multiplier || this.multiplier.discountpct == null) return 1;
    return 1 + this.multiplier.discountpct;
  }

  /**
   * Galvanized Plate Base Top Covers need to be handled specially, and
   * Marella Add-Ons are not to be displayed here.
   * Obtain the correct pricing for fabric grade accessories and non-TC
   * accessories with finish variants by creating new accessory objects
   * for each variant and pushing to the accessories array.
   */
  get accessories(): Accessory[] {
    // filter out marella add-ons
    const hiddenModels = [
      "MLA-FC",
      "MLA-SW",
      "MLA-FW",
      "MLA-HC",
      "883MLA-BS",
      "CANOPY-ONLY"
    ];
    let accessories = ((this.collections as any) as Accessory[]).filter(
      item => !hiddenModels.includes(item.model)
    );
    // handle fabric grade priced accessories (msrp === 0 with a/b/c values)
    const fabricGrades: Array<"a" | "b" | "c"> = ["a", "b", "c"];
    const fabricGradeAccessories: Accessory[] = [];
    accessories = accessories.filter(item => {
      if (
        item.price_id &&
        item.price_id.msrp === 0 &&
        fabricGrades.some(g => item.price_id![g] && item.price_id![g]! > 0)
      ) {
        fabricGrades.forEach(grade => {
          const gradePrice = item.price_id![grade];
          if (gradePrice && gradePrice > 0) {
            const gradeAccessory = { ...item };
            gradeAccessory.price_id = { ...item.price_id! };
            gradeAccessory.display_name = `${
              item.display_name
            } - Grade ${grade.toUpperCase()}`;
            gradeAccessory.model = `${
              item.model
            } (Grade ${grade.toUpperCase()})`;
            gradeAccessory.price_id!.msrp = gradePrice;
            fabricGradeAccessories.push(gradeAccessory);
          }
        });
        return false;
      }
      return true;
    });
    accessories = accessories.concat(fabricGradeAccessories);

    // handle non-TC accessories with finish variants (e.g. CMLK-ST)
    const finishAccessories: Accessory[] = [];
    accessories = accessories.filter(item => {
      const isTC = item.model.substring(item.model.length - 3) === "-TC";
      if (
        !isTC &&
        item.finishes &&
        item.finishes.length > 0 &&
        item.price_id &&
        item.price_id.finishes &&
        item.price_id.finishes.length > 0
      ) {
        item.finishes.forEach(finishObj => {
          const finishItem = { ...item };
          finishItem.price_id = { ...item.price_id! };
          finishItem.model = `${
            item.model
          }-${((finishObj.handle as any) as string).toUpperCase()}`;
          finishItem.display_name = `${item.display_name} - ${finishObj.display_name} Finish`;
          const priceFinishObj = item.price_id!.finishes!.find(
            fp => fp.handle === finishObj.handle
          );
          const upcharge = priceFinishObj ? priceFinishObj.upcharge : 0;
          finishItem.price_id!.msrp = item.price_id!.msrp + upcharge;
          finishItem.price_id!.model = finishItem.model;
          finishAccessories.push(finishItem);
        });
        return false;
      }
      return true;
    });
    accessories = accessories.concat(finishAccessories);

    // handle G Plate TCs
    const topCoverModels: Accessory[] = [];
    accessories = accessories.filter(item => {
      if (item.model.substring(item.model.length - 3) === "-TC") {
        topCoverModels.push(item);
        return false;
      }
      return true;
    });
    topCoverModels.forEach((topCover, index) => {
      topCover.finishes!.forEach((finishObj, idx) => {
        const topCoverAccessory = { ...topCoverModels[index] };
        topCoverAccessory.price_id = { ...topCoverModels[index].price_id! };
        topCoverAccessory.model = `${
          topCover.model
        }-${((finishObj.handle as any) as string).toUpperCase()}`;
        topCoverAccessory.display_name = `${topCoverAccessory.display_name} - ${finishObj.display_name} Finish`;
        const priceFinishObj = topCoverAccessory.price_id!.finishes!.find(
          finishPrice => finishPrice.handle === finishObj.handle
        );
        topCoverAccessory.price_id!.msrp = priceFinishObj!.upcharge;
        topCoverAccessory.price_id!.model = topCoverAccessory.model;
        accessories.push(topCoverAccessory);
      });
    });
    return accessories;
  }

  get itemPriceTotal(): number {
    let price = 0;
    for (const item of this.lineItems) {
      price = price + item.unit_price * item.qty * item.multiplier;
    }
    return price;
  }

  get msrpTotal(): number {
    let price = 0;
    for (const item of this.lineItems) {
      price = price + item.unit_price * item.qty;
    }
    return price;
  }

  protected addToQuote() {
    let itemsQty = 0;
    for (const item of this.lineItems) {
      item.multiplier = this.multiplierValue;
      this.addItem(item);
      itemsQty += item.qty;
    }
    EventBus.$emit("addToCartModal", {
      qty: itemsQty,
      accessoryList: this.lineItems
    });
  }

  protected setQty(qty: number, model: string): void {
    this.triggerUpdate(model, { qty });
  }

  protected triggerUpdate(
    model: string,
    options: { qty?: number; multiplier?: number }
  ): void {
    if (options.qty === 0) {
      this.removeLineItem(model);
    } else {
      this.updateLineItem(model, options);
    }
  }

  protected removeLineItem(model: string): void {
    this.lineItems = this.lineItems.filter(item => item.model !== model);
  }

  protected updateLineItem(
    model: string,
    options: { qty?: number; multiplier?: number }
  ): void {
    const index = this.lineItems.findIndex(item => item.model === model);
    if (index > -1) {
      const obj = { ...this.lineItems[index] };
      obj.qty = options.qty ? options.qty : obj.qty;
      obj.multiplier = this.multiplierValue;
      this.lineItems.splice(index, 1, obj);
    } else if (options.qty) {
      this.addNewLineItem(model, options);
    }
  }

  protected addNewLineItem(
    model: string,
    options: { qty?: number; multiplier?: number }
  ) {
    const item = this.accessories.find(item => item.model === model);
    const itemObj = {
      product_type: ProductType.Accessory,
      multiplier: this.multiplierValue,
      sku: "",
      model: model,
      product_line: "",
      qty: options.qty!,
      unit_price: item!.price_id ? item!.price_id.msrp : 0,
      display_name: item!.display_name,
      notes: "",
      item_details: { notes: [{ field: "model", content: "" }] as Note[] }
    };
    this.lineItems.push(itemObj);
  }

  // Triggered from child component, <Search />
  protected submitSearch(searchTerm: string): void {
    this.search = searchTerm;
  }

  get filteredAccessories() {
    if (this.search != "") {
      const term = this.search.toLowerCase();
      return this.accessories.filter(item => {
        return (
          item.model.toLowerCase().indexOf(term) !== -1 ||
          item.display_name.toLowerCase().indexOf(term) !== -1
        );
      });
    } else {
      return this.accessories;
    }
  }
}
